<template>
  <div class="active-window">
    <image-modal
      v-if="imageModalShow"
      :link="imageLink"
      @close="imageModalShow = false"
    />
    <div
      class="ticket-details"
      v-if="!loading"
      :class="{ expanded: isTicketInfoExpanded }"
    >
      <div class="info">
        <div class="column basic">
          <div class="user-info">
            <basic-info
              :profilePictureURL="
                baseURL + basicInfo.post.profilePic.link_to_thumb
              "
              :name="basicInfo.post.authorName"
              :description="basicInfo.post.divDescription"
            />
          </div>
          <div class="dates">
            <div class="single-date">
              <b>Datum objave</b>
              <span>{{ basicInfo.post.time }}</span>
            </div>
            <!-- 
            <div class="single-date">
              <b>Poslednja izmena</b>
              <span>{{ ticketDetails.last_edit | formatDateTime }}</span>
            </div>-->
          </div>
        </div>
        <div class="column right">
          <div class="description">
            <b>Detalji objave</b>
            <p v-if="isTicketInfoExpanded">
              {{ basicInfo.post.body }}
              <br />
            </p>
            <p v-if="!isTicketInfoExpanded">
              {{
                basicInfo.post.body.length > 200
                  ? basicInfo.post.body.substring(0, 200) + '...'
                  : basicInfo.post.body
              }}
              <br />
            </p>
          </div>
          <div
            class="files-info"
            v-if="
              !isTicketInfoExpanded &&
                basicInfo.post.medias &&
                basicInfo.post.medias.length !== 0
            "
            @click="toggleTicketInfo"
          >
            <i class="fa fa-paperclip" aria-hidden="true"></i>
            <span>
              {{ basicInfo.post.medias.length }}
              {{
                basicInfo.post.medias.length === 1
                  ? 'fajl'
                  : basicInfo.post.medias.length > 4
                  ? 'fajlova'
                  : 'fajla'
              }}
            </span>
          </div>
          <div
            class="files-area"
            v-if="
              isTicketInfoExpanded &&
                basicInfo.post.medias &&
                basicInfo.post.medias.length !== 0
            "
          >
            <div class="images-wrapper">
              <a
                v-for="i in imageFiles"
                :key="i.link"
                @click="openImagePreview(baseURL + i.link)"
              >
                <img :src="baseURL + i.link_to_thumb" />
              </a>
            </div>
            <a
              class="file"
              v-for="f in otherFiles"
              :key="f.link"
              :href="baseURL + f.link"
              target="_blank"
            >
              <p>{{ f.file_name }}</p>
              <a>
                <i class="fas fa-file-download"></i>
              </a>
            </a>
          </div>
          <a
            v-if="
              (basicInfo.post.medias || basicInfo.post.body.length > 200) &&
                !isTicketInfoExpanded
            "
            @click="toggleTicketInfo"
            class="show-more-info"
            >Proširi pregled</a
          >

          <a
            v-if="
              (basicInfo.post.medias || basicInfo.post.body.length > 200) &&
                isTicketInfoExpanded
            "
            @click="toggleTicketInfo"
            class="show-more-info"
            >Smanji pregled</a
          >
        </div>
      </div>

      <div id="comments-area">
        <div
          id="comments"
          ref="comments"
          :class="{ expanded: isTicketInfoExpanded }"
        >
          <div class="no-comments" v-if="getCommentsNumber === 0">
            <p>Trenutno nema komentara</p>
          </div>
          <comment
            v-for="c in comments"
            :comment="c"
            :postId="basicInfo.post.postId"
            :key="c.comment_id"
          ></comment>
        </div>
        <div id="new-comment-section">
          <p class="uploaded-file" v-if="attachmentName">
            {{ attachmentName }}
            <span class="btn btn-primary" @click="clearAttachInput">
              <i class="fas fa-times"></i>
            </span>
          </p>
          <div id="upload-area">
            <div
              id="add-img-wrapper"
              @click="uploadFileClicked"
              v-if="!commentUploadUrl"
            >
              <i class="fas fa-paperclip"></i>
            </div>
            <div id="attached-img-wrapper" v-if="commentUploadUrl">
              <div class="hover-shadow" @click="clearAttachInput">
                <i class="far fa-trash-alt"></i>
              </div>
              <img
                :src="commentUploadUrl"
                id="comment-upload-pic"
                alt="slika"
              />
            </div>
          </div>
          <div class="textarea-wrapper">
            <textarea
              @keydown.enter="handleOnEnter"
              class="form-control"
              :class="{ 'textarea-error': comment.length > 300 }"
              rows="3"
              placeholder="Unesite komentar"
              v-model="comment"
              ref="messageTextArea"
              :style="{ height: messageTextAreaHeight + 'px' }"
              @input="autoresizeTextarea"
            ></textarea>
            <div
              class="character-counter"
              :class="{ 'character-counter-error': comment.length > 300 }"
            >
              {{ comment.length }}/300
            </div>
          </div>
          <div id="new-comment-control">
            <input
              @change="fileAttached"
              ref="commentUpload"
              type="file"
              style="display:none"
            />
            <button
              :disabled="comment.length === 0 || commentSending"
              class="btn btn-primary btn--mod"
              @click="submitComment"
            >
              <slot>
                <spinner
                  :size="20"
                  line-fg-color="#00796b"
                  v-if="commentSending"
                />
              </slot>
              <slot v-if="!commentSending">
                Pošalji
                <!-- <i class="fas fa-paper-plane"></i> -->
              </slot>
            </button>
          </div>
        </div>
      </div>
    </div>
    <spinner
      spinner
      class="spinner"
      line-fg-color="#00796b"
      :size="100"
      :line-size="6"
      v-if="loading"
    ></spinner>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import BasicInfo from '@/components/common/BasicInfo.vue';
import Comment from '@/components/common/Comment.vue';
import axios from '@/axios/axios.js';
import { formatDateMixin } from '@/mixins/mixins.js';
import ImageModal from '@/components/modal/ModalImage.vue';

export default {
  name: 'Ticket',
  components: {
    comment: Comment,
    basicInfo: BasicInfo,
    ImageModal
  },
  mixins: [formatDateMixin],
  data() {
    return {
      baseURL: process.env.VUE_APP_OBJECT_STORAGE_URL,
      comment: '',
      commentSending: false,
      commentUploadUrl: '',
      commentUploadFile: null,
      isTicketInfoExpanded: false,
      messageTextAreaHeight: 40,
      comments: [],
      imageModalShow: false,
      imageLink: '',
      attachmentName: null
    };
  },
  computed: {
    ...mapState('post', ['basicInfo']),
    ...mapState(['loading']),
    getCommentsNumber() {
      if (this.comments == null || this.comments.length === 0) {
        return 0;
      } else {
        return 1;
      }
    },
    imageFiles() {
      const imageTypes = ['image/gif', 'image/jpeg', 'image/png'];
      return this.basicInfo.post.medias.filter(
        el => imageTypes.indexOf(el.type) > -1
      );
    },
    otherFiles() {
      const imageTypes = ['image/gif', 'image/jpeg', 'image/png'];
      return this.basicInfo.post.medias.filter(
        el => imageTypes.indexOf(el.type) === -1
      );
    }
  },
  created() {
    this.setPostTitle('Detalji objave');
    this.getPostComments();
  },
  destroyed() {
    this.clearTicketModule();
  },
  methods: {
    ...mapActions('ticket', ['getTicketDetails', 'getTicketComments']),
    ...mapMutations('ticket', ['clearTicketModule']),
    ...mapMutations('modal', ['setTicket', 'showModal']),
    ...mapActions('modal', ['showFailModal']),
    ...mapMutations(['setPostTitle']),
    async getPostComments() {
      const data = await axios.post('post/get-comments', {
        community_id: this.$store.getters.getActiveCommunity.id,
        post_id: this.basicInfo.post.postId,
        futureOrPast: 1,
        numOfPosts: 999
      });
      try {
        this.comments = this.restructureComments(data.data);
      } catch (err) {
        console.log(err);
      }
    },
    openImagePreview(link) {
      this.imageLink = link;
      this.imageModalShow = true;
    },
    restructureComments(data) {
      return data.map(el => {
        return {
          member_id: el.author_id,
          full_name: el.author_name,
          comment_body: el.body,
          link: el.profile_pic.link,
          timestamp: el.date,
          medias: el.medias ? el.medias : [],
          com_media_link: el.medias == null ? null : el.medias[0].link,
          communityMembers: null,
          numOfResponses: el.num_of_comments,
          comment_id: el.comment_id
        };
      });
    },
    clearAttachInput() {
      this.$refs.commentUpload.value = '';
      this.commentUploadUrl = '';
      this.commentUploadFile = null;
      this.attachmentName = null;
    },
    handleOnEnter(e) {
      if (this.commentSending) {
        return;
      }
      if (e.ctrlKey) {
        this.submitComment();
      }
    },
    uploadFileClicked() {
      if (!this.attachmentName) {
        this.$refs.commentUpload.click();
      }
    },
    autoresizeTextarea(event) {
      event.target.style.height = 'auto';
      event.target.style.height = event.target.scrollHeight + 'px';
      if (event.target.scrollHeight > 110) {
        event.target.style.height = '110px';
      }
    },
    toggleTicketInfo() {
      this.isTicketInfoExpanded = !this.isTicketInfoExpanded;
    },
    fileAttached(event) {
      // if (!this.validateInput(event.target.value)) {
      //   this.showFailModal('Fajl mora biti jpg, jpeg ili png');
      //   this.clearAttachInput();
      //   return;
      // }
      // validate file size
      if (event.target.files[0].size > 5122059) {
        this.showFailModal('Fajl ne može biti veći od 5MB');
        return;
      }
      // check if attachment is image
      if (this.validateInput(event.target.value)) {
        this.commentUploadUrl = URL.createObjectURL(event.target.files[0]);
      } else {
        this.attachmentName = event.target.files[0].name;
      }
      this.commentUploadFile = event.target.files[0];
    },
    validateInput(value) {
      let allowedExtensions = ['jpg', 'jpeg', 'png'];
      let extension = value.substring(value.lastIndexOf('.') + 1, value.length);
      return allowedExtensions.indexOf(extension) > -1;
    },
    submitComment() {
      if (this.comment.trim().length > 300) {
        this.showFailModal('Komentar može imati najviše 300 karaktera.');
        return;
      }
      this.commentSending = true;
      if (this.commentUploadFile != null) {
        axios
          .post('media/add', this.formatMediaForSubmit(), {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(({ data }) => {
            axios
              .post('post', {
                body: this.comment.trim(),
                community_id: this.$store.getters.getActiveCommunity.id,
                direct_post_receiver_id: 0,
                event: null,
                parent_post_id: this.basicInfo.post.postId,
                post_type: 5,
                voting: null,
                member_id: this.$store.getters.getActiveCommunity.member_id,
                media_ids: [data.ids[0]]
              })
              .then(res => {
                this.commentSending = false;
                this.getPostComments();
                this.resetInputFields();
                this.$nextTick(() => {
                  this.$refs.comments.scrollTop = 0;
                });
              })
              .catch(e => {
                this.commentSending = false;
                console.log(e);
              });
          })
          .catch(error => {
            this.commentSending = false;
            console.log(error);
            this.showFailModal();
          });
      } else {
        axios
          .post('post', {
            body: this.comment.trim(),
            community_id: this.$store.getters.getActiveCommunity.id,
            direct_post_receiver_id: 0,
            event: null,
            parent_post_id: this.basicInfo.post.postId,
            post_type: 5,
            voting: null,
            member_id: this.$store.getters.getActiveCommunity.member_id,
            media_ids: []
          })
          .then(res => {
            this.commentSending = false;
            this.getPostComments();
            this.resetInputFields();
            this.$nextTick(() => {
              this.$refs.comments.scrollTop = 0;
            });
          })
          .catch(e => {
            this.commentSending = false;
            console.log(e);
          });
      }
    },
    resetInputFields() {
      this.comment = '';
      this.messageTextAreaHeight = 40;
      this.clearAttachInput();
    },
    formatMediaForSubmit() {
      if (this.commentUploadFile != null) {
        let fd = new FormData();
        fd.append(
          'files[]',
          this.commentUploadFile,
          this.commentUploadFile.name
        );
        fd.append('type', 'community');
        fd.append('community_id', this.$store.getters.getActiveCommunity.id);

        return fd;
      }
      return null;
    }
  }
};
</script>

<style scoped lang="scss">
.active-window {
  // height: calc(100% - 120px);
  height: calc(100vh - 104px);
}
.character-counter {
  right: 105px;
}
.ticket-details {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 100%;
  /*min-width: 450px;*/
  padding: 10px;
  &.expanded {
    height: unset;
  }
  hr {
    margin-left: 0;
    margin-right: 0;
  }
  .info {
    flex: 20%;
    position: relative;
    border: 1px solid gray;
    border-radius: 4px;
    padding: 10px;
    display: flex;
    min-height: 180px;
    .column {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &.basic {
        .user-info {
          display: flex;
          padding-right: 6px;
        }
        .dates {
          display: flex;
          flex-direction: column;
          text-align: left;
          margin: 0;
          margin-top: 20px;
          .single-date {
            // margin-top: 2px;
            display: flex;
            flex-direction: column;
            span {
              margin-top: -4px;
            }
          }
        }
      }
      &.right {
        // border: 1px solid red;
        flex: 3;
        justify-content: flex-start;
        .badges {
          // width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          // margin-top: 5px;
          .statbar {
            margin-right: 3px;
          }
        }
        .description {
          padding: 3px 5px;
          // background-color: #fabb4738;
          /* border: 1px solid #000000; */
          border-radius: 3px;
          p {
            // max-height: 120px;
            overflow: auto;
            margin-top: 4px !important;
          }
        }
        .files-info {
          border: 1px solid gray;
          border-radius: 6px;
          // width: 140px;
          width: fit-content;
          padding: 4px 8px;
          // padding-left: 10px;
          font-weight: 600;
          display: inline-flex;
          justify-content: center;
          cursor: pointer;
          i {
            font-size: 22px;
            margin-right: 8px;
          }
          &:hover {
            background: rgba(108, 108, 108, 0.05);
          }
        }
        .files-area {
          margin-top: 10px;
          width: 100%;
          text-align: left;
          // max-height: 86px;
          justify-content: space-between;
          overflow-y: auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          resize: none;

          .images-wrapper {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            padding-bottom: 12px;
            img {
              width: 100px;
              height: 100px;
              object-fit: cover;
              margin-right: 12px;
              border-radius: 6px;
              &:hover {
                opacity: 0.7;
                cursor: pointer;
              }
            }
          }

          .file {
            display: flex;
            align-items: center;
            // flex-shrink: 0;
            flex: 0 0 49%;
            max-width: 49%;
            background-color: #d5d5d54a;
            margin-bottom: 6px;
            margin-right: 6px;
            height: auto;
            // margin: 4px;
            border-radius: 4px;
            color: black;

            p {
              // word-break: break-word;
              margin-bottom: 0;
              width: 100%;
              // white-space: nowrap;
              // text-overflow: ellipsis;
              overflow: hidden;
              // direction: rtl;
              padding: 4px;
            }

            i {
              color: var(--primary-color);
              float: right;
              margin: 0 15px;
            }
          }
        }
      }
    }
    .btn--mod {
      // position: absolute;
      // right: 10px;
      // top: 10px;
      flex: 0 0 0;
      // margin-left: auto;
      margin-left: 12px;
      padding: 3px;
      vertical-align: middle;
      height: 35px;
      min-width: 75px;
    }
    .show-more-info {
      margin-top: 8px;
      color: var(--primary-color);
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  #comments-area {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    justify-content: space-between;
    flex: 100;
    #comments {
      overflow: auto;
      padding-right: 10px;
      &.expanded {
        max-height: 54vh;
        min-height: 20vh;
      }
    }
    #new-comment-section {
      .uploaded-file {
        position: absolute;
        bottom: 55px;
        background: var(--primary-color);
        border-radius: 4px 4px 0 0;
        padding: 0px 8px;
        color: white;
        text-align: left;
        span {
          padding-right: 0;
        }
      }
      // flex: 100px;
      margin-top: 15px;
      height: auto;
      display: inline-flex;
      align-items: flex-end;
      width: 100%;
      textarea {
        resize: none;
      }

      #upload-area {
        // min-width: 40px;
        // max-width: 40px;
        height: 40px;
        width: 45px;
        margin-right: 5px;
        background-color: rgba(211, 211, 211, 0.37);
        border-radius: 5px;
        overflow: hidden;

        #attached-img-wrapper {
          .hover-shadow {
            border-radius: 5px;
            opacity: 0;
            min-width: 40px;
            min-height: 40px;
            background-color: rgba(0, 0, 0, 0.41);
            position: absolute;
            transition: opacity 0.2s;
            display: flex;
            justify-content: center;
            align-items: center;
            i {
              color: white;
            }
          }
        }

        #attached-img-wrapper:hover {
          .hover-shadow {
            opacity: 1;
          }
        }

        #add-img-wrapper {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .fa-paperclip {
          transition: color 0.25s;
          font-size: 25px;
        }

        img {
          width: 40px;
          height: 40px;
          object-fit: scale-down;
        }
      }

      #upload-area:hover {
        cursor: pointer;
        .fa-paperclip {
          color: var(--primary-color);
        }
      }

      #new-comment-control {
        display: flex;
        float: right;
        align-items: flex-end;

        button {
          margin-left: 5px;
          height: 40px;
          // width: 40px;
          i {
            font-size: 35px;
          }
        }

        #comment-upload-btn {
          margin-right: 5px;
          font-size: 20px;
        }
      }
    }
  }
}

.hidden {
  display: flex;
  display: none;

  .ticket-info {
    display: flex;
    position: relative;
    width: 30%;
    min-width: 300px;
    flex-grow: 1;
    flex-shrink: 4;
    flex-direction: column;
  }

  .description {
    text-align: center;
    margin-bottom: 40px;
    h5 {
      display: inline-block;
      padding-bottom: 5px;
      border-bottom: 2px solid var(--primary-color);
    }
    p {
      max-height: 120px;
      overflow: auto;
    }
  }

  .user-info {
    display: flex;
  }

  .basic-info {
    padding-left: 10px;
    text-align: start;
    h5 {
      color: var(--primary-color);
      font-weight: bold;
    }
  }

  .badges {
    display: flex;
    align-content: flex-start;
    margin-bottom: 15px;
    margin-top: 5px;
    .statbar {
      margin-right: 3px;
    }
  }

  .no-comments {
    text-align: center;
    margin-top: 30px;
  }

  .uploaded-content {
    margin: 5px 10px 0 10px;
    width: 150px;
    height: auto;
    object-fit: scale-down;
    border-radius: 5px;
  }

  .border {
    margin: 0 10px;
  }

  .btn--mod {
    flex: 0 0 0;
    margin-left: auto;
    padding: 3px;
    vertical-align: middle;
    height: 35px;
    min-width: 75px;
  }

  #comments-area {
    flex-shrink: 1;
    flex-grow: 4;
    width: 50%;
    margin: 0 15px;
  }

  .ticket-section {
    display: flex;
    position: relative;
  }

  #comments {
    overflow-y: auto;
    height: calc(100% - 200px);
    padding: 0 15px;
    border-left: 1px solid rgba(108, 108, 108, 0.55);
    border-right: 1px solid rgba(108, 108, 108, 0.55);
  }

  .ticket-header {
    padding: 10px;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin: 5px 5px 0 5px;
  }

  .files-area {
    width: 100%;
    text-align: left;
    max-height: 60%;
    justify-content: space-between;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    resize: none;
  }

  .file {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    background-color: #d5d5d54a;
    margin-bottom: 1px;
    height: auto;

    p {
      word-break: break-word;
      margin-bottom: 0;
      width: 100%;
    }

    i {
      color: var(--primary-color);
      float: right;
      margin: 0 15px;
    }
  }

  .content-area {
    display: flex;
    flex-shrink: 4;
    flex-grow: 1;
    width: 30%;
    flex-direction: column;
    text-align: justify;
  }

  .dates {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-bottom: 25px;
    p {
      margin-bottom: 5px;
    }
  }

  .spinner {
    margin-top: 100px;
  }

  .profile-pic {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 50%;
    overflow: hidden;
  }

  #new-comment-section {
    margin-top: 15px;
    height: auto;
    display: inline-flex;
    width: 100%;
    textarea {
      resize: none;
    }

    #upload-area {
      min-width: 85px;
      max-width: 85px;
      margin-right: 5px;
      background-color: rgba(211, 211, 211, 0.37);
      border-radius: 5px;
      overflow: hidden;

      #attached-img-wrapper {
        .hover-shadow {
          border-radius: 5px;
          opacity: 0;
          min-width: 85px;
          min-height: 85px;
          background-color: rgba(0, 0, 0, 0.41);
          position: absolute;
          transition: opacity 0.2s;
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            color: white;
          }
        }
      }

      #attached-img-wrapper:hover {
        .hover-shadow {
          opacity: 1;
        }
      }

      #add-img-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .fa-paperclip {
        transition: color 0.25s;
        font-size: 25px;
      }

      img {
        width: 85px;
        height: 85px;
        object-fit: cover;
      }
    }

    #upload-area:hover {
      cursor: pointer;
      .fa-paperclip {
        color: var(--primary-color);
      }
    }

    #new-comment-control {
      display: flex;
      float: right;
      align-items: center;

      button {
        margin-left: 5px;
      }

      #comment-upload-btn {
        margin-right: 5px;
        font-size: 20px;
      }
    }
  }
}
</style>
